/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable default-param-last */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { L2OrderbookActionTypes } from 'actionTypes/l2Orderbook';
import { ORDER_BOOK_TAB_TYPES } from 'constants/enums';
import type { OrderbookTabType } from 'types/IOrderbook';

export interface IBuySell {
  average: string;
  depth: number;
  depthPercentage: number;
  price: string;
  quotingNotionalSum: number;
  settlingNotionalSum: string;
  size: number;
  underlyingNotionalSum: string;
}

export interface IL2Orderbook {
  buy: IBuySell[];
  sell: IBuySell[];
  type: 'l2_orderbook';
  symbol: string;
  product_id: number;
  last_sequence_no: number;
  // last_updated_at: number;
  // timestamp: number;
  error?: boolean | null;
  selectedPriceClubbingValue: number;
  selectedPriceClubbingValueIndex: number;
  bestBid: number;
  bestAsk: number;
  bestBidSize: number;
  bestAskSize: number;
  spread: undefined | number;
  percentage_spread: undefined | number;
  tabSelected: OrderbookTabType;
}

interface IAction {
  type: L2OrderbookActionTypes;
  payload: IL2Orderbook;
}

const initialState: IL2Orderbook = {
  buy: [],
  sell: [],
  type: 'l2_orderbook',
  symbol: '',
  product_id: -1,
  last_sequence_no: -1,
  // last_updated_at: -1,
  // timestamp: -1,
  error: null,
  selectedPriceClubbingValue: -1,
  selectedPriceClubbingValueIndex: 0,
  bestBid: 0,
  bestAsk: 0,
  bestBidSize: 0,
  bestAskSize: 0,
  spread: undefined,
  percentage_spread: undefined,
  tabSelected: ORDER_BOOK_TAB_TYPES.BOTH,
};

const l2Orderbook = (state = initialState, action: IAction) => {
  switch (action.type) {
    case L2OrderbookActionTypes.SNAPSHOT: {
      return {
        ...state,
        buy: action.payload?.buy,
        sell: action.payload?.sell,
        type: action?.payload?.type,
        symbol: action?.payload?.symbol,
        product_id: action?.payload?.product_id,
        last_sequence_no: action?.payload?.last_sequence_no,
        // last_updated_at: action?.payload?.last_updated_at,
        // timestamp: action?.payload?.timestamp,
        error: action?.payload?.error,
        bestBid: action?.payload?.bestBid,
        bestAsk: action?.payload?.bestAsk,
        bestBidSize: action?.payload?.bestBidSize,
        bestAskSize: action?.payload?.bestAskSize,
        spread: action?.payload?.spread,
        percentage_spread: action?.payload?.percentage_spread,
      };
    }
    case L2OrderbookActionTypes.ERROR: {
      return {
        ...state,
        error: action.payload?.error,
      };
    }
    case L2OrderbookActionTypes.UPDATE: {
      return {
        ...state,
        selectedPriceClubbingValue: action.payload?.selectedPriceClubbingValue,
        selectedPriceClubbingValueIndex: action.payload?.selectedPriceClubbingValueIndex,
      };
    }
    case L2OrderbookActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    case L2OrderbookActionTypes.EMPTY_SELL_ORDERS: {
      return {
        ...state,
        sell: initialState.sell,
      };
    }
    case L2OrderbookActionTypes.UPDATE_ACTIVE_TAB: {
      return {
        ...state,
        tabSelected: action.payload,
      };
    }
    default:
      return state;
  }
};

export default l2Orderbook;
